(function () {
  'use strict';

  /* ========= CONFIG ========= */

  const BEER_TYPE = 'Bière';
  const BEER_MULTIPLE = 12;
  const BEER_MAX = 72;
  const CONTACT_URL =
    'https://brassindesfrangins.fr/pages/contact';

  let cartIsDirty = false;

  /* ========= DOM ========= */

  let checkoutButton;
  let dynamicCheckoutButtons;
  let beerError;
  let cgvCheckbox;
  let ageCheckbox;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    checkoutButton = document.querySelector('input[name="checkout"]');
    dynamicCheckoutButtons = document.querySelector('.additional-checkout-buttons');
    cgvCheckbox = document.getElementById('cgv-checkbox');
    ageCheckbox = document.getElementById('age-checkbox');

    if (!checkoutButton) return;

    createBeerError();
    bindEvents();

    // Validation systématique au chargement (panier réel)
    validateCart();
  }

  /* ========= UI ========= */

  function createBeerError() {
    beerError = document.createElement('div');
    beerError.id = 'beer-cart-error';
    beerError.style.cssText =
      'display:none;color:#d72c0d;background:#fef2f2;padding:12px;margin:12px 0;border-left:4px solid #d72c0d;font-size:14px';

    checkoutButton.parentNode.insertBefore(beerError, checkoutButton);
  }

  function setCheckoutState(allowed) {
    checkoutButton.disabled = !allowed;
    checkoutButton.style.opacity = allowed ? '1' : '0.5';
    checkoutButton.style.cursor = allowed ? 'pointer' : 'not-allowed';

    if (dynamicCheckoutButtons) {
      dynamicCheckoutButtons.style.pointerEvents = allowed ? 'auto' : 'none';
      dynamicCheckoutButtons.style.opacity = allowed ? '1' : '0.5';
    }
  }

  /* ========= DATA ========= */

  async function getBeerQuantityFromCart() {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    const cart = await res.json();

    return cart.items.reduce((total, item) => {
      return item.product_type === BEER_TYPE
        ? total + item.quantity
        : total;
    }, 0);
  }

  /* ========= VALIDATION ========= */

  async function validateCart() {
    // Panier propre uniquement après reload Shopify
    cartIsDirty = false;

    let beerQty = 0;

    try {
      beerQty = await getBeerQuantityFromCart();
    } catch (e) {
      return;
    }

    const checkboxesValid =
      (!cgvCheckbox || cgvCheckbox.checked) &&
      (!ageCheckbox || ageCheckbox.checked);

    let valid = true;
    let message = '';

    if (beerQty > 0) {
      if (beerQty > BEER_MAX) {
        valid = false;
        message = `
          Quantité limitée à 72 bières par commande.<br>
          Besoin de plus ?
          <a href="${CONTACT_URL}"
             style="color:#d72c0d;text-decoration:underline;font-weight:600">
            Contactez-nous pour un devis personnalisé.
          </a>
        `;
      } else if (beerQty % BEER_MULTIPLE !== 0) {
        valid = false;
        const missing = BEER_MULTIPLE - (beerQty % BEER_MULTIPLE);
        message = `
          <strong>Vente par cartons de ${BEER_MULTIPLE} bières.</strong><br>
          Il vous manque <strong>${missing}</strong> bière${missing > 1 ? 's' : ''} pour compléter votre carton.
        `;
      }
    }

    if (!valid) {
      beerError.innerHTML = message;
      beerError.style.display = 'block';
    } else {
      beerError.style.display = 'none';
    }

    setCheckoutState(valid && checkboxesValid && !cartIsDirty);
  }

  /* ========= EVENTS ========= */

  function bindEvents() {
    if (cgvCheckbox) cgvCheckbox.addEventListener('change', validateCart);
    if (ageCheckbox) ageCheckbox.addEventListener('change', validateCart);

    // Toute modification de quantité invalide le checkout
    document.addEventListener('input', (e) => {
      if (e.target.matches('input[name="updates[]"]')) {
        cartIsDirty = true;
        beerError.innerHTML = 'Veuillez mettre à jour le panier pour continuer.';
        beerError.style.display = 'block';
        setCheckoutState(false);
      }
    });
  }
})();
